module.exports = require("next/dist/client/components/request-async-storage.external.js");